<template>
  <span>
    <v-badge
      :value="hasTip"
      :content="tipAmount.toFixed(2)"
      overlap
      color="primary"
    >
      <v-btn
        fab
        small
        depressed
        :color="active ? 'primary' : 'secondary'"
        class="ml-3"
        @click="showForm = true"
      >
        <v-icon v-text="icons.tip" />
      </v-btn>
    </v-badge>
    <v-dialog
      v-model="showForm"
      persistent
      no-click-animation
      max-width="380"
    >
      <h-tip-form
        v-model="tipAmount"
        @close="showForm = false"
      />
    </v-dialog>
  </span>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HTipForm from './TipForm'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HTipForm,
    },

    data: () => ({
      showForm: false,
    }),

    computed: {
      tipAmount: {
        get () {
          return this.$store.state.orders.payment.tipAmount
        },
        set (v) {
          this.$store.commit('orders/payment/tipAmount', v)
        },
      },
      hasTip () {
        return this.tipAmount.greaterThan(0)
      },
      active () {
        return this.hasTip || this.showForm
      },
    },
  }
</script>
